export default __webpack_public_path__ + "fonts/Inter-Medium.woff2";